import { Alert, Heading, VFlow } from 'bold-ui'
import React from 'react'
import { Accordion, AccordionItem } from 'react-accessible-accordion'

import { NewsInternalEstabilizacaoV41 } from './NewsInternalEstabilizacaoV_41'
import { NewsInternalEstabilizacaoV42 } from './NewsInternalEstabilizacaoV_42'
import { NewsInternalPanelV4_0 as NewsInternalPanelVQuatro } from './NewsInternalPanelV4_0'
import { NewsInternalPanelV4_10 as NewsInternalPanelVQuatroUm } from './NewsInternalPanelV4_10'
import { NewsInternalPanelV4_20 as NewsInternalPanelVQuatroDois } from './NewsInternalPanelV4_20'
import { NewsInternalVEstabilizacao } from './NewsInternalVEstabilizacao'
import { NewsSection } from './NewsSection'

export function News() {
  return (
    <>
      <VFlow>
        <Heading level={1}>Novidades da versão</Heading>
        <Alert type='info' inline>
          <strong>O PEC está sendo redesenhado para ficar ainda mais fácil de usar!</strong> A cada versão, diferentes
          módulos serão atualizados com a nova interface. Para receber as próximas novidades, o sistema deve ser
          atualizado com a versão mais recente disponível.
        </Alert>
        <Accordion allowZeroExpanded={true} preExpanded={['estabilizacaoV42']}>
          <AccordionItem uuid='estabilizacaoV42'>
            <NewsSection title='Versões de estabilização (4.2)'>
              <NewsInternalEstabilizacaoV42 />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.2'>
            <NewsSection title='Versão 4.2'>
              <NewsInternalPanelVQuatroDois />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='estabilizacaoV41'>
            <NewsSection title='Versões de estabilização (4.1)'>
              <NewsInternalEstabilizacaoV41 />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.1'>
            <NewsSection title='Versão 4.1'>
              <NewsInternalPanelVQuatroUm />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='estabilizacao'>
            <NewsSection title='Versões de estabilização (4.0)'>
              <NewsInternalVEstabilizacao />
            </NewsSection>
          </AccordionItem>
          <AccordionItem uuid='4.0'>
            <NewsSection title='Versão 4.0'>
              <NewsInternalPanelVQuatro />
            </NewsSection>
          </AccordionItem>
        </Accordion>
      </VFlow>
    </>
  )
}
